
      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;

var $f1FvE = parcelRequire("f1FvE");
const $63385af4379935c7$var$CONFIG = {
    EMAILJS_PUBLIC_KEY: "6Ih25VGn6JauSMCGr",
    EMAILJS_SERVICE_ID: "service_a7b1l5w",
    EMAILJS_TEMPLATE_ID: "template_y20rm9c",
    MAX_SUBMISSIONS_PER_DAY: 2,
    LOCK_DURATION_MS: 86400000,
    HOUR_UPDATE_INTERVAL: 3600000,
    MINUTE_UPDATE_INTERVAL: 300000,
    STORAGE_KEYS: {
        LOCK_RESET_TIME: "contactForm_lockResetTime",
        DAILY_SUBMISSIONS: "contactForm_dailySubmissions"
    }
};
// Validate configuration
function $63385af4379935c7$var$validateConfig() {
    if (!$63385af4379935c7$var$CONFIG.EMAILJS_PUBLIC_KEY || !$63385af4379935c7$var$CONFIG.EMAILJS_SERVICE_ID || !$63385af4379935c7$var$CONFIG.EMAILJS_TEMPLATE_ID) return false;
    return true;
}
const $63385af4379935c7$var$Storage = {
    getLockResetTime () {
        const value = localStorage.getItem($63385af4379935c7$var$CONFIG.STORAGE_KEYS.LOCK_RESET_TIME);
        if (!value) return null;
        const timestamp = parseInt(value, 10);
        return isNaN(timestamp) ? null : timestamp;
    },
    setLockResetTime (timestampMs) {
        localStorage.setItem($63385af4379935c7$var$CONFIG.STORAGE_KEYS.LOCK_RESET_TIME, String(timestampMs));
    },
    clearLock () {
        localStorage.removeItem($63385af4379935c7$var$CONFIG.STORAGE_KEYS.LOCK_RESET_TIME);
    },
    getSubmissions () {
        const data = localStorage.getItem($63385af4379935c7$var$CONFIG.STORAGE_KEYS.DAILY_SUBMISSIONS);
        return data ? JSON.parse(data) : {};
    },
    setSubmissions (submissions) {
        localStorage.setItem($63385af4379935c7$var$CONFIG.STORAGE_KEYS.DAILY_SUBMISSIONS, JSON.stringify(submissions));
    },
    cleanupOldSubmissions () {
        const today = new Date().toDateString();
        const submissions = this.getSubmissions();
        const cleaned = {};
        if (submissions[today]) cleaned[today] = submissions[today];
        this.setSubmissions(cleaned);
    }
};
const $63385af4379935c7$var$SubmissionManager = {
    canSubmit () {
        const now = Date.now();
        const lockResetTime = $63385af4379935c7$var$Storage.getLockResetTime();
        if (lockResetTime && now < lockResetTime) return false;
        if (lockResetTime && now >= lockResetTime) $63385af4379935c7$var$Storage.clearLock();
        $63385af4379935c7$var$Storage.cleanupOldSubmissions();
        const today = new Date().toDateString();
        const submissions = $63385af4379935c7$var$Storage.getSubmissions();
        const todayCount = submissions[today] || 0;
        return todayCount < $63385af4379935c7$var$CONFIG.MAX_SUBMISSIONS_PER_DAY;
    },
    recordSubmission () {
        const today = new Date().toDateString();
        const submissions = $63385af4379935c7$var$Storage.getSubmissions();
        submissions[today] = (submissions[today] || 0) + 1;
        $63385af4379935c7$var$Storage.setSubmissions(submissions);
        if (submissions[today] >= $63385af4379935c7$var$CONFIG.MAX_SUBMISSIONS_PER_DAY) {
            const lockResetTime = Date.now() + $63385af4379935c7$var$CONFIG.LOCK_DURATION_MS;
            $63385af4379935c7$var$Storage.setLockResetTime(lockResetTime);
        }
    },
    getRemainingSubmissions () {
        const today = new Date().toDateString();
        const submissions = $63385af4379935c7$var$Storage.getSubmissions();
        const used = submissions[today] || 0;
        return Math.max(0, $63385af4379935c7$var$CONFIG.MAX_SUBMISSIONS_PER_DAY - used);
    },
    isLocked () {
        const lockResetTime = $63385af4379935c7$var$Storage.getLockResetTime();
        return lockResetTime && Date.now() < lockResetTime;
    },
    getTimeUntilReset () {
        const lockResetTime = $63385af4379935c7$var$Storage.getLockResetTime();
        if (!lockResetTime) return 0;
        const remaining = lockResetTime - Date.now();
        return Math.max(0, remaining);
    }
};
const $63385af4379935c7$var$UI = {
    updateTimer: null,
    updateTooltip () {
        const tooltipText = document.querySelector(".tooltip-text");
        const tooltipFooter = document.querySelector(".tooltip-footer span");
        if (!tooltipText || !tooltipFooter) return;
        const remaining = $63385af4379935c7$var$SubmissionManager.getRemainingSubmissions();
        const isLocked = $63385af4379935c7$var$SubmissionManager.isLocked();
        const timeUntilReset = $63385af4379935c7$var$SubmissionManager.getTimeUntilReset();
        if ((0, $f1FvE.isRTL)()) tooltipText.textContent = `\u{644}\u{62F}\u{64A}\u{643} ${remaining} \u{645}\u{646} ${$63385af4379935c7$var$CONFIG.MAX_SUBMISSIONS_PER_DAY} \u{645}\u{62D}\u{627}\u{648}\u{644}\u{627}\u{62A} \u{625}\u{631}\u{633}\u{627}\u{644} \u{645}\u{62A}\u{628}\u{642}\u{64A}\u{629}`;
        else tooltipText.textContent = `You have ${remaining}/${$63385af4379935c7$var$CONFIG.MAX_SUBMISSIONS_PER_DAY} submissions left`;
        if (isLocked && timeUntilReset > 0) {
            const timeText = this.formatTimeRemaining(timeUntilReset);
            if ((0, $f1FvE.isRTL)()) tooltipFooter.textContent = `\u{64A}\u{64F}\u{639}\u{627}\u{62F} \u{636}\u{628}\u{637}\u{647} \u{62E}\u{644}\u{627}\u{644} ${timeText}`;
            else tooltipFooter.textContent = `Restarts in ${timeText}`;
        } else if ((0, $f1FvE.isRTL)()) tooltipFooter.textContent = `\u{64A}\u{64F}\u{639}\u{627}\u{62F} \u{636}\u{628}\u{637}\u{647} \u{62E}\u{644}\u{627}\u{644} 24h `;
        else tooltipFooter.textContent = `Restarts in 24h`;
        this.scheduleNextUpdate();
    },
    formatTimeRemaining (ms) {
        const hours = Math.floor(ms / 3600000);
        const minutes = Math.ceil(ms % 3600000 / 60000);
        if (hours >= 1) return `${hours}h`;
        else if (minutes > 0) return `${minutes}m`;
        else {
            if ((0, $f1FvE.isRTL)()) return "\u0623\u0642\u0644 \u0645\u0646 1m";
            else return "less than 1m";
        }
    },
    scheduleNextUpdate () {
        if (this.updateTimer) {
            clearTimeout(this.updateTimer);
            this.updateTimer = null;
        }
        const timeUntilReset = $63385af4379935c7$var$SubmissionManager.getTimeUntilReset();
        if (timeUntilReset === 0) {
            this.updateTimer = setTimeout(()=>this.updateTooltip(), $63385af4379935c7$var$CONFIG.HOUR_UPDATE_INTERVAL);
            return;
        }
        if (timeUntilReset >= $63385af4379935c7$var$CONFIG.HOUR_UPDATE_INTERVAL) {
            const msToNextHour = timeUntilReset % $63385af4379935c7$var$CONFIG.HOUR_UPDATE_INTERVAL || $63385af4379935c7$var$CONFIG.HOUR_UPDATE_INTERVAL;
            this.updateTimer = setTimeout(()=>this.updateTooltip(), msToNextHour + 100);
        } else this.updateTimer = setTimeout(()=>this.updateTooltip(), $63385af4379935c7$var$CONFIG.MINUTE_UPDATE_INTERVAL);
    },
    showPopup (popupId) {
        const popup = document.getElementById(popupId);
        if (popup) popup.classList.add("show");
    },
    closePopup (popupId) {
        const popup = document.getElementById(popupId);
        if (popup) popup.classList.remove("show");
    },
    closeAllPopups () {
        document.querySelectorAll(".popup-overlay").forEach((popup)=>{
            popup.classList.remove("show");
        });
    },
    setSubmitButtonState (disabled, text) {
        const submitBtn = document.getElementById("form__submit_btn");
        const submitText = submitBtn?.querySelector("span");
        if (submitBtn) submitBtn.disabled = disabled;
        if (submitText) submitText.textContent = text;
    }
};
const $63385af4379935c7$var$FormHandler = {
    init () {
        // Validate configuration first
        if (!$63385af4379935c7$var$validateConfig()) {
            $63385af4379935c7$var$UI.showConfigError();
            return;
        }
        // Check if emailjs is available
        if (typeof emailjs === "undefined") {
            $63385af4379935c7$var$UI.showConfigError();
            return;
        }
        // Initialize EmailJS
        try {
            emailjs.init($63385af4379935c7$var$CONFIG.EMAILJS_PUBLIC_KEY);
        } catch (error) {
            $63385af4379935c7$var$UI.showConfigError();
            return;
        }
        // Set up form event listener
        const form = document.getElementById("contactForm");
        if (form) form.addEventListener("submit", (e)=>this.handleSubmit(e));
        else return;
        // Set up popup close buttons
        document.querySelectorAll(".popup-btn").forEach((btn)=>{
            btn.addEventListener("click", ()=>$63385af4379935c7$var$UI.closeAllPopups());
        });
        // Close popup on overlay click
        document.querySelectorAll(".popup-overlay").forEach((overlay)=>{
            overlay.addEventListener("click", (e)=>{
                if (e.target === overlay) $63385af4379935c7$var$UI.closeAllPopups();
            });
        });
        // Tooltip functionality
        document.querySelectorAll(".tooltip-trigger").forEach((trigger)=>{
            trigger.addEventListener("click", (e)=>{
                e.stopPropagation();
                const tooltip = trigger.nextElementSibling;
                if (tooltip && tooltip.classList.contains("tooltip-content")) tooltip.style.pointerEvents = tooltip.style.pointerEvents === "auto" ? "none" : "auto";
            });
        });
        // Close tooltips on outside click
        document.addEventListener("click", ()=>{
            document.querySelectorAll(".tooltip-content").forEach((tooltip)=>{
                tooltip.style.pointerEvents = "none";
            });
        });
        // Update tooltip when page becomes visible
        document.addEventListener("visibilitychange", ()=>{
            if (document.visibilityState === "visible") $63385af4379935c7$var$UI.updateTooltip();
        });
        // Initial tooltip update
        $63385af4379935c7$var$UI.updateTooltip();
    },
    async handleSubmit (e) {
        e.preventDefault();
        // Check submission limit
        if (!$63385af4379935c7$var$SubmissionManager.canSubmit()) {
            $63385af4379935c7$var$UI.showPopup("errorPopup");
            const errorMessage = document.querySelector("#errorPopup .popup-message");
            if (errorMessage) {
                if ((0, $f1FvE.isRTL)()) errorMessage.textContent = "\u0644\u0642\u062F \u0648\u0635\u0644\u062A \u0625\u0644\u0649 \u0627\u0644\u062D\u062F \u0627\u0644\u0623\u0642\u0635\u0649 \u0627\u0644\u064A\u0648\u0645 \u0644\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0626\u0644. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u0627\u064B.";
                else errorMessage.textContent = "You have reached your daily submission limit. Please try again later.";
            }
            return;
        }
        // Update button state
        if ((0, $f1FvE.isRTL)()) $63385af4379935c7$var$UI.setSubmitButtonState(true, "\u062C\u0627\u0631\u064A \u0627\u0644\u0625\u0631\u0633\u0627\u0644...");
        else $63385af4379935c7$var$UI.setSubmitButtonState(true, "Sending...");
        try {
            const response = await emailjs.sendForm($63385af4379935c7$var$CONFIG.EMAILJS_SERVICE_ID, $63385af4379935c7$var$CONFIG.EMAILJS_TEMPLATE_ID, e.target);
            if (response.status === 200) {
                $63385af4379935c7$var$SubmissionManager.recordSubmission();
                $63385af4379935c7$var$UI.updateTooltip();
                $63385af4379935c7$var$UI.showPopup("successPopup");
                e.target.reset();
            } else throw new Error(`EmailJS returned status: ${response.status}`);
        } catch (error) {
            $63385af4379935c7$var$UI.showPopup("errorPopup");
            const errorMessage = document.querySelector("#errorPopup .popup-message");
            if (errorMessage) {
                if ((0, $f1FvE.isRTL)()) errorMessage.textContent = "\u062D\u062F\u062B \u062E\u0637\u0623 \u0645\u0627. \u064A\u0631\u062C\u0649 \u0627\u0644\u0645\u062D\u0627\u0648\u0644\u0629 \u0645\u0631\u0629 \u0623\u062E\u0631\u0649 \u0644\u0627\u062D\u0642\u064B\u0627.";
                else errorMessage.textContent = "Something went wrong. Please try again later.";
            }
        } finally{
            // Reset button state
            if ((0, $f1FvE.isRTL)()) $63385af4379935c7$var$UI.setSubmitButtonState(false, "\u0625\u0631\u0633\u0627\u0644 \u0627\u0644\u0631\u0633\u0627\u0644\u0629");
            else $63385af4379935c7$var$UI.setSubmitButtonState(false, "Send Message");
        }
    }
};
// Global function for popup close button
window.closePopup = (popupId)=>{
    if (popupId) $63385af4379935c7$var$UI.closePopup(popupId);
    else $63385af4379935c7$var$UI.closeAllPopups();
};
// Initialize when DOM is ready
if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", ()=>$63385af4379935c7$var$FormHandler.init());
else $63385af4379935c7$var$FormHandler.init();
window.addEventListener("languageChanged", ()=>{
    $63385af4379935c7$var$UI.updateTooltip();
});
// Tooltip mobile
document.addEventListener("DOMContentLoaded", function() {
    const tooltipTriggers = document.querySelectorAll(".tooltip-trigger");
    // Only apply this for touch devices
    if ("ontouchstart" in window) tooltipTriggers.forEach((trigger)=>{
        const tooltip = trigger.nextElementSibling;
        if (tooltip && tooltip.classList.contains("tooltip-content")) {
            // Prevent default hover behavior
            trigger.addEventListener("click", function(e) {
                e.preventDefault();
                e.stopPropagation();
                // Close all other tooltips first
                document.querySelectorAll(".tooltip-content").forEach((t)=>{
                    if (t !== tooltip) t.classList.remove("tooltip-active");
                });
                // Toggle this tooltip
                tooltip.classList.toggle("tooltip-active");
            });
            // Close tooltip when clicking outside
            document.addEventListener("click", function(e) {
                if (!trigger.contains(e.target) && !tooltip.contains(e.target)) tooltip.classList.remove("tooltip-active");
            });
            // Close tooltip when tapping the backdrop (if you add one)
            tooltip.addEventListener("click", function(e) {
                if (e.target === tooltip) tooltip.classList.remove("tooltip-active");
            });
        }
    });
});
// API Credits footer
document.addEventListener("DOMContentLoaded", function() {
    const apiToggle = document.getElementById("apiCreditsToggle");
    const apiCredits = document.getElementById("apiCredits");
    function isMobile() {
        return window.innerWidth <= 768;
    }
    if (apiToggle && apiCredits) {
        apiToggle.addEventListener("click", function(e) {
            if (isMobile()) {
                e.preventDefault();
                apiToggle.classList.toggle("active");
                apiCredits.classList.toggle("show");
                const isExpanded = apiCredits.classList.contains("show");
                apiToggle.setAttribute("aria-expanded", isExpanded);
            }
        });
        // Set initial aria-expanded attribute
        apiToggle.setAttribute("aria-expanded", "false");
        document.addEventListener("click", function(e) {
            if (isMobile() && apiToggle && apiCredits) {
                // If clicking outside the toggle and credits area
                const apiContainer = apiToggle.closest(".footer__api-container");
                if (apiContainer && !apiContainer.contains(e.target)) {
                    apiToggle.classList.remove("active");
                    apiCredits.classList.remove("show");
                    apiToggle.setAttribute("aria-expanded", "false");
                }
            }
        });
        let resizeTimer;
        window.addEventListener("resize", function() {
            clearTimeout(resizeTimer);
            resizeTimer = setTimeout(function() {
                if (!isMobile()) {
                    // Switching to desktop
                    apiToggle.classList.remove("active");
                    apiCredits.classList.remove("show");
                    apiToggle.setAttribute("aria-expanded", "false");
                }
            }, 250);
        });
    }
});


//# sourceMappingURL=repo.6530d55b.js.map
